import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import '../App.css';

interface SharedDocData {
  title: string | null;
  markdown: string;
  s3_key?: string;
  expires_at: string;
}

export default function SharedDoc({ token }: { token: string }) {
  const [doc, setDoc] = useState<SharedDocData | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const API_BASE = process.env.REACT_APP_API_URL || '/api';
    fetch(`${API_BASE}/docs/shared/${token}`)
      .then(res => {
        if (!res.ok) throw new Error('expired');
        return res.json();
      })
      .then(setDoc)
      .catch(() => setError('링크가 만료되었거나 존재하지 않습니다'))
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#1a1a2e', color: '#ccc' }}>
        <div>문서를 불러오는 중...</div>
      </div>
    );
  }

  if (error || !doc) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#1a1a2e', color: '#ccc', gap: '16px' }}>
        <div style={{ fontSize: '48px' }}>🔗</div>
        <div style={{ fontSize: '18px', fontWeight: 600 }}>{error}</div>
        <div style={{ color: '#888', fontSize: '14px' }}>공유 링크가 만료되었거나 잘못된 주소입니다</div>
      </div>
    );
  }

  const expiresAt = new Date(doc.expires_at);
  const remaining = Math.max(0, Math.floor((expiresAt.getTime() - Date.now()) / 3600000));

  return (
    <div style={{ minHeight: '100vh', background: '#1a1a2e', color: '#e0e0e0', padding: '0' }}>
      {/* Header */}
      <div style={{
        background: '#16213e',
        borderBottom: '1px solid #2a2a4a',
        padding: '16px 32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div>
          <div style={{ fontSize: '18px', fontWeight: 600, color: '#fff' }}>
            {doc.title || (doc.s3_key ? doc.s3_key.split('/').pop() : 'Document')}
          </div>
          <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>
            공유 문서 · 약 {remaining}시간 후 만료
          </div>
        </div>
        <div style={{ fontSize: '13px', color: '#555' }}>LINKO Agent</div>
      </div>

      {/* Document content */}
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '32px' }}>
        <div className="markdown-body">
          <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw, rehypeSanitize]}>
            {doc.markdown}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
}
